/**
 * Download a file the browser can fetch directly, e.g. a signed URL returned
 * by an export query/mutation. The anchor is removed right after the click, so
 * this is not suitable for blob URLs — those also need `URL.revokeObjectURL`.
 */
export function triggerFileDownload(url: string) {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = '';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
